export default "__VITE_ASSET__72b2d35f__"